import {
  assign, endpoint, options, check, convert,
} from '../helpers';

/**
 * Requires users to have access to the report.
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const permission = (properties) => {
  const props = assign(properties);
  const model = {
    Report: props.data.report || '',
    Users: props.data.users.map(item => ({
      Username: item.username || '',
      Permission: item.permission,
    })),
  };

  fetch(endpoint('/save-report-user-list'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        props.success(convert(response.Message));
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default permission;
